<template>
  <div id="fm_sidebar_container">
    <fm_filter_search></fm_filter_search>
    <hr style="width: 66%; margin-left: auto; margin-right: auto;">
    <fm_filter_sources></fm_filter_sources>
    <div v-if="loadingChannels" style="text-align: center"><i class="el-icon-loading"></i></div>
    <hr style="width: 66%; margin-left: auto; margin-right: auto;">
    <fm_filter_star_rating></fm_filter_star_rating>
    <div v-if="loadingStars" style="text-align: center"><i class="el-icon-loading"></i></div>
    <hr style="width: 66%; margin-left: auto; margin-right: auto;">
    <fm_filter_calltoaction></fm_filter_calltoaction>
  </div>
</template>

<script>
  import FilterSelectSources from '../fm_filters/FilterSelectTestimonialSources.vue';
  import FilterCallToAction from '../fm_filters/FilterCallToActionButton.vue';
  import FilterStarRating from '../fm_filters/FilterSelectStarRating.vue';
  import FilterSearch from '../fm_filters/FilterSearch.vue';

  import axios from 'axios';

  export default {
    components: {
      'fm_filter_sources': FilterSelectSources,
      'fm_filter_calltoaction': FilterCallToAction,
      'fm_filter_star_rating': FilterStarRating,
      'fm_filter_search': FilterSearch
    },
    data(){
      return {
        filterDataFromWP:'',
        channelObject: {},
        starObject: {},
        categoriesObject: {},
        loadingStars: false,
        loadingChannels: false
      }
    },
    methods: {

    },
    computed: {

    },
    created(){
      /*get all filter data and pass it on to the according sections via global storage*/
      this.loadingChannels = true;
      this.loadingStars    = true;

      //make axios call to WP Backend to get all kinds of filter data
      const reqFilterData = new FormData();
      reqFilterData.append('action','fm_vue_frontend_api_filters')

      axios.post('', reqFilterData)
           .then( response => {
             //update channels
              this.channelObject = response.data.channels;

             //update star rating
              this.starObject = response.data.stars;

             //store channels and stars and other data globally
              this.$store.dispatch('setChannels', this.channelObject);
              this.$store.dispatch('setStars', this.starObject);
              this.$store.dispatch('setNumTotalResults', response.data.total_reviews);

              //hide loading givs
              this.loadingStars     = false;
              this.loadingChannels  = false;

              //get first results from server and show loading button
              this.$store.dispatch('setMPPFetchingResultsNow', true);
              this.$store.dispatch('globalActionMPPFetchResults').then(response => {

              });
           })
           .catch( error => {
             console.log(error)
             //hide loading givs
             this.loadingStars     = false;
             this.loadingChannels  = false;
           });


      //channel

      //stars

      //categories



    }
  }
</script>

<style scoped lang="scss">
  #fm_sidebar_container {
    border: solid #EBEEF5 1px;
    padding: 15px;
    border-radius: 7px;

    -webkit-box-shadow: 0px 0px 4px 0px rgba(227,224,227,1);
    -moz-box-shadow: 0px 0px 4px 0px rgba(227,224,227,1);
    box-shadow: 0px 0px 4px 0px rgba(227,224,227,1);
  }
</style>